module.exports = __webpack_public_path__ + "static/media/Vicino5.692bfc34.jpg";